export const ROUTES = {
  home: '/',
  howItWorks: '/how-it-works',
  security: '/security',
  caseStudies: '/case-studies',
  adoptionLegacy: '/adoption',
  contact: '/contact',
} as const;
